import SlimSelect, {Config} from "slim-select"

const init = () => {
  const selects = document.querySelectorAll(".f-single-select:not(.--initialized)")

  selects.forEach((select) => {
    const selectInput = select.querySelector(".f-single-select__select.slim-select")

    if (!selectInput) return

    select.classList.remove("--native")

    const SETTINGS: Config = {
      select: selectInput,
      settings: {
        showSearch: selectInput.hasAttribute("search"),
        searchText: selectInput.getAttribute("data-search-empty") ?? undefined,
        searchPlaceholder: selectInput.getAttribute("data-search-placeholder") ?? undefined,
        hideSelected: !selectInput.hasAttribute("multiple"),
        closeOnSelect: !selectInput.hasAttribute("multiple"),
        allowDeselect: selectInput.hasAttribute("multiple"),
        placeholderText: selectInput.getAttribute("data-placeholder") ?? "",
        maxValuesShown: parseInt(selectInput.getAttribute("data-max-shown") ?? "") || undefined,
        maxValuesMessage: selectInput.getAttribute("data-max-shown-message") ?? undefined,
      },
    }

    new SlimSelect(SETTINGS)
    select.classList.add("--initialized")
  })
}

init()
document.addEventListener("singleSelectReinit", init)
